import useRecentFilterSetsHandler from '../FilterSetsList.js/useRecentFilterSetsHandler';
import { FilterIcon, ProjectIcon } from '@linearb/linui-common';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import useContextActions from '../../../../useContextActions';

const mapFilterSetTypeToIcon = {
  [SAVED_FILTER_SET_TYPES.FILTER_SET]: FilterIcon,
  [SAVED_FILTER_SET_TYPES.PROJECT]: ProjectIcon
};

const useRecentFilterSetsMenuItems = Context => {
  const contextActions = useContextActions({ Context });

  const recentFilterSetsHandler = useRecentFilterSetsHandler(Context);

  const menuItems = recentFilterSetsHandler.recentFilterSets.map(filterSet => {
    return {
      label: filterSet?.name,
      Icon: mapFilterSetTypeToIcon[filterSet.type],
      onClick: async () => {
        await contextActions.onSelectFilterSet(filterSet);
        recentFilterSetsHandler.updateRecentFilterSetIds(filterSet?.id);
      }
    };
  });

  return menuItems;
};

export default useRecentFilterSetsMenuItems;
